import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import {
  EstadoIncidenciaIA,
  IncidenciaIA,
  IncidenciaIAComentario,
  IncidenciaIAReq,
  IncidenciaIARes,
} from "../shared/model/iso42001/incidencia-ia.model";

@Injectable({
  providedIn: "root",
})
export class IncidenciasIAService {
  constructor(private http: HttpClient) {}

  consultarKanban(
    filtro: IncidenciaIA,
    regInicial: number,
    regXPagina: number,
  ): Observable<IncidenciaIARes> {
    const req: IncidenciaIAReq = { filtro, regInicial, regXPagina };
    return this.http.post<IncidenciaIARes>(
      UrlConstantes.ISO42001_INCIDENCIA_IA_CONSULTAR_KANBAN,
      req,
    );
  }

  obtener(idIncidenciaIa: number): Observable<IncidenciaIARes> {
    const req: IncidenciaIAReq = { idIncidenciaIa };
    return this.http.post<IncidenciaIARes>(
      UrlConstantes.ISO42001_INCIDENCIA_IA_OBTENER,
      req,
    );
  }

  consultarResponsables(): Observable<IncidenciaIARes> {
    const req: IncidenciaIAReq = {};
    return this.http.post<IncidenciaIARes>(
      UrlConstantes.ISO42001_INCIDENCIA_IA_RESPONSABLES,
      req,
    );
  }

  guardar(incidencia: IncidenciaIA): Observable<IncidenciaIARes> {
    const req: IncidenciaIAReq = { incidencia };
    return this.http.post<IncidenciaIARes>(
      UrlConstantes.ISO42001_INCIDENCIA_IA_GUARDAR,
      req,
    );
  }

  actualizar(incidencia: IncidenciaIA): Observable<IncidenciaIARes> {
    const req: IncidenciaIAReq = { incidencia };
    return this.http.post<IncidenciaIARes>(
      UrlConstantes.ISO42001_INCIDENCIA_IA_ACTUALIZAR,
      req,
    );
  }

  cambiarEstado(
    idIncidenciaIa: number,
    estadoEvento: EstadoIncidenciaIA,
    incidencia?: IncidenciaIA,
    comentario?: IncidenciaIAComentario,
  ): Observable<IncidenciaIARes> {
    const req: IncidenciaIAReq = { idIncidenciaIa, estadoEvento, incidencia, comentario };
    return this.http.post<IncidenciaIARes>(
      UrlConstantes.ISO42001_INCIDENCIA_IA_CAMBIAR_ESTADO,
      req,
    );
  }

  guardarComentario(comentario: IncidenciaIAComentario): Observable<IncidenciaIARes> {
    const req: IncidenciaIAReq = { comentario };
    return this.http.post<IncidenciaIARes>(
      UrlConstantes.ISO42001_INCIDENCIA_IA_GUARDAR_COMENTARIO,
      req,
    );
  }
}
